export default __webpack_public_path__ + "static/media/portfolio-simple-2-p3.b82f6d55.jpg";